<template>
  <div>


  <div class="section_header mobile_div mt-2 mb-2" >
    <div class="row d-flex justify-content-center mt-5 mb-5">
      <div class="col-md-12 mt-2">
        <input type="date" class="form-control" placeholder="Дата" @change="changeCurrentDate"  v-model="current_date"/>
      </div>
      <div class="col-md-12 mt-2">
        <p><a  href="javascript:void;" @click="changeCurrentDatetoNull">Показать всех<br>без даты и времени</a></p>
      </div>

    </div>

  </div>
    <div class="section_header  mobile_div mt-2 mb-2" v-if="projects.length==0 && is_load==true">
      <h2 >Заявок  не найдено!</h2>
    </div>

    <div class="section_header mobile_div section_gray_bg" v-if="projects.length>0 && is_load==true" v-for="(project,project_index) in projects" :key="project.last_id">
      <div class="row mt-3 ">
        <div class="col-12 col-md-6">

          <router-link  :to="{name: 'project', params: { id: project.last_id }}"
              class=" btn btn-sm ml-1 title_project_card text-truncate" tag="a">{{ project.name_project }}</router-link>

          <div class="card-body">
            <p class="card-text">Дата создания: {{ project.created_at }}</p>
            <p class="card-text">Дата обновления: {{ project.updated_at }}</p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card-body">
            <h5 class="card-title" v-if="project.manage_spectator==0 && project.developer">Исполнитель: {{ project.developer.name}}</h5>
            <p class="card-text" v-if="project.status_row && project.status_row.issearch==1 && project.offers_count">Предложений ({{ project.offers_count }})</p>

            <p class="card-text" v-if="project.status_row && project.status_row.issearch==1 && project.my_offers_count && project.my_offers_count>0"><i class="fa fa-check-circle" title="вы уже отправили предложение"></i>&nbsp; отправлено</p>
            <p class="card-text" v-if="project.manage_spectator==0 && project.client">Клиент: {{ project.client.name}}</p>
            <p class="card-text" v-if="project.service && project.service.name">{{ project.service.name}}</p>
            <p class="card-text" v-if="project.main_project_id==0">Статус проекта: {{ project.status_row.title}}</p>
            <p class="card-text" v-if="project.main_project_id>0">Статус задачи: {{ project.status_row.title}} </p>
          </div>
        </div>
      </div>
      <div class="card-footer mb-3  ">
        <div class="row">
          <div class="col-12 col-md-6 mt-2 mb-2">
            <p><b>Дата записи </b></p>
            <p>{{ projects_data['project_'+project.last_id]['final_date'] }}<button @click="clearDate(project)"  class="btn"><i class="fa fa-pencil"></i></button></p>

            <div class="alert alert-danger" v-if="projects_data['project_'+project.last_id]['is_error']==true">
              <p >{{ projects_data['project_'+project.last_id].error_message }} </p>
            </div>
            <p v-if="projects_data['project_'+project.last_id]['is_edit']==true" class="text-center">Выберите дату и время</p>
            <p v-if="projects_data['project_'+project.last_id]['is_edit']==true" class="text-center"><input   @change="chooseDate(project)" type="date" class="col-12 form-control"  v-model="projects_data['project_'+project.last_id]['date_field']['date']"    ></p>
            <p v-if="projects_data['project_'+project.last_id]['is_edit']==true && projects_data['project_'+project.last_id]['date_field']['slots'] && projects_data['project_'+project.last_id]['date_field']['slots'].length>0" class="text-center">
              <select class="form-control" @change="chooseTime(project)" v-model="projects_data['project_'+project.last_id]['date_field']['time']">
                <option v-for="(slot,slot_key) in projects_data['project_'+project.last_id]['date_field']['slots']" :key="slot_key" :value="slot">{{ slot }}</option>
              </select>

            </p>


          </div>

          <div class="col-12 col-md-6  mt-2 mb-2 text-right">
            <router-link v-if="project.main_project_id==0" :to="{name: 'project', params: { id: project.last_id }}"
                class="btn btn-sm" tag="a">Перейти</router-link>
            <router-link v-if="project.main_project_id!=0" :to="{name: 'project', params: { id: project.last_id }}"
                class="btn btn-sm" tag="a">Перейти</router-link>
          </div>
        </div>


      </div>
    </div>
    <div class="col-12 col-sm-12 mt-5 ml-1  " v-if="count>offset && is_load==true">
      <div class="row second_section d-flex justify-content-center">
        <button class="btn" @click="loadProjects">Загрузить еще</button>

      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/models/Api";

export default {
  name: "CalendarList",
  data() {

    var app = this;

    return {
      "is_load":false,
      "current_date":"",
      "limit":20,
      "count":0,
      'offset':0,
      'projects':[],
      'projects_data':{

      },
      'user':{},


    }
  },
  mounted(){
    var app=this;
    app.current_date=app.getCurrentDate();

    app.loadProjects();
  },
  methods:{
    clearDate(project){
      var app=this;
      var projects_data=app.projects_data;


      projects_data['project_'+project.last_id].date_field.date  = "";
      projects_data['project_'+project.last_id].date_field.time  = "";
      projects_data['project_'+project.last_id].date_field.slots = [];
      projects_data['project_'+project.last_id].final_date="";
      projects_data['project_'+project.last_id].is_edit=true;

      app.projects_data=projects_data;


    },
    chooseTime(project){
      var app=this;
     var projects_data=app.projects_data;
        projects_data['project_'+project.last_id].final_date=projects_data['project_'+project.last_id].date_field['date']+" "+projects_data['project_'+project.last_id].date_field['time'];
        projects_data['project_'+project.last_id].is_edit=false;
      app.projects_data=projects_data;

      app.changeProjectDate(project);
    },
    chooseDate(project){
      var app=this;

      var projects_data=app.projects_data;
      var current_date=projects_data['project_'+project.last_id].date_field['date'];
      projects_data['project_'+project.last_id].date_field['slots']=[];
      projects_data['project_'+project.last_id].is_error=false;
      app.projects_data=projects_data;
      Api.loadScheduleByService(project.category_id,current_date,project.developer_id,function(data){
        app.projects_data['project_'+project.last_id].date_field['slots']=data.slots;
      },function(message){
        app.projects_data['project_'+project.last_id].is_error=true;
        app.projects_data['project_'+project.last_id].error_message=message;
      });
    },

    changeProjectDate(project){
      var app=this;
      var json={};
      json["datetime_client"]=app.projects_data['project_'+project.last_id].final_date;
      Api.updateProjectDateClient(project.last_id,json,function(data){
        app.projects_data['project_'+project.last_id].is_error=false;
        app.projects_data['project_'+project.last_id].error_message="";
        app.changeCurrentDate();
      },function(err){
        app.projects_data['project_'+project.last_id].is_error=true;
        app.projects_data['project_'+project.last_id].error_message=err;

      })

    },
    changeCurrentDatetoNull(){
      var app=this;
      app.current_date="";
      app.offset=0;
      app.projects=[];
      app.loadProjects();
    },
    changeCurrentDate(){
      var app=this;
      app.offset=0;
      app.projects=[];
      app.loadProjects();
    },
    getCurrentDate(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      today =yyyy+"-"+mm+"-"+dd;
      return today;
    },
    loadProjects(){
      var app=this;
      app.is_load=false;
      Api.loadProjectsCalendar(app.limit,app.offset,app.current_date,function(data){
        app.count=data.count;
        app.offset=data.offset;
        app.user=data.me;
        if(data.projects.length>0){
        app.projects=app.projects.concat(data.projects);
        var projects_data={};
        data.projects.forEach(function(project) {
              projects_data['project_' + project.last_id] = {
                "date_field"   : {
                  "date" : "",
                  "time" : "",
                  'slots': [],

                },
                'final_date':project.datetime_client,
                'is_edit'      : false,
                'is_error'     : false,
                'error_message': '',
              };
            }
        );
          app.projects_data=projects_data;
        }



        app.is_load=true;
      });
    }
  }
}
</script>

<style scoped>

</style>